import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { isInSalesDemo } from '@shared/store/selectors/security.selector';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * ITP-P-54 D19: XatBot Show is hidden inside a sales demo (Empty / Restored), because presenting a show starts another
 * demo. A route under this guard sends the user home from a sales demo; inside a Show instance (D24) and outside any
 * demo it opens as before.
 */
@Injectable({
  providedIn: 'root'
})
export class NotInSalesDemoGuard implements CanActivate {
  constructor(private router: Router, private securityStore: Store<SecurityState>) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.securityStore.select(isInSalesDemo).pipe(
      take(1),
      map(inSalesDemo => inSalesDemo ? this.router.createUrlTree(['']) : true)
    );
  }
}
